import { Box, Stack, Tooltip, Typography, useColorScheme, useTheme, Modal, ModalDialog, ModalClose, DialogTitle, DialogContent, DialogActions, Divider } from "@mui/joy";
import MuneyIcon from "../../icons/muney";
import { useContext, useState } from "react";
import UIContext from "../../../store/ui";
import { useNavigate } from "react-router-dom";
import SessionContext from "../../../store";
import CustomInput from "../custom_elements/customInput";
import PrimaryButton from "../custom_elements/primaryButton";
import SecondaryButton from "../custom_elements/secondaryButton";
import axios from 'axios';

const SideBar = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const { menu, setActiveMenuItem, clearMenu } = useContext(UIContext);
    const { session, logOut } = useContext(SessionContext);

    const [openConfiguration, setOpenConfiguration] = useState(false);
    const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loadingChangePassword, setLoadingChangePassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const { mode, setMode } = useColorScheme();

    const closeSession = async () => {
        try {
            await logOut();
            setActiveMenuItem(0);
            clearMenu();
            navigate("/");
        } catch(error) {
            console.error("Error al cerrar sesión:", error);
        }
    };

    const getUserTypeLabel = () => {
        if (!session || !session.type) return "";
        return session.type === "admin" ? "Administrador" : "Operador";
    };

    const handleChangePassword = async () => {
        if (!oldPassword || !newPassword || !confirmPassword) {
            setErrorMessage('Por favor complete todos los campos');
            return;
        }

        if (newPassword !== confirmPassword) {
            setErrorMessage('Las contraseñas no coinciden');
            return;
        }

        if (newPassword.length < 6) {
            setErrorMessage('La contraseña debe tener al menos 6 caracteres');
            return;
        }

        setLoadingChangePassword(true);
        setErrorMessage('');
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_URL_API}/orders/me/update-password`,
                {
                    old_password: oldPassword,
                    new_password: newPassword
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${session.token}`
                    }
                }
            );

            if (response.status === 200) {
                setSuccessMessage('Contraseña actualizada exitosamente');
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
                setTimeout(() => {
                    setChangePasswordModalOpen(false);
                }, 2000);
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                setErrorMessage('Contraseña anterior incorrecta');
            } else {
                setErrorMessage('Error al actualizar la contraseña');
            }
        } finally {
            setLoadingChangePassword(false);
        }
    };

    return (
        <>
            <Box 
                sx={{
                    maxHeight: "100dvh",
                    height: "100%",
                    backgroundColor: theme.palette.background.sideBar,
                    position: "relative"
                }}
            >
                <Box display="flex" justifyContent="end" padding="16px">
                    <Box m={0} p={0} sx={{cursor: "pointer"}} onClick={()=> {navigate("/tx"); setActiveMenuItem(0);}}>
                        <MuneyIcon />
                    </Box>
                </Box>
                <Tooltip
                    placement="top-end"
                    type="plain"
                    sx={{
                        backgroundColor: theme.vars.palette.background.body, 
                        borderRadius: "16px", 
                        paddingX: "8px", 
                        paddingY: "16px"
                    }}
                    title={
                        openConfiguration && (
                            <Box sx={{width: "224px"}}>
                                <Box>
                                    <Typography sx={{
                                        fontFamily: "Montserrat",
                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: 700,
                                        lineHeight: "150%",
                                        color: theme.vars.palette.text.main
                                    }}>
                                        {getUserTypeLabel()}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography sx={{
                                        fontFamily: "Montserrat",
                                        fontSize: "12px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "130%",
                                        color: theme.vars.palette.text.main
                                    }}>
                                        {session?.username || ""}
                                    </Typography>
                                </Box>
                                <Box mt={3} display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography sx={{
                                        fontFamily: "Montserrat",
                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: 700,
                                        lineHeight: "150%",
                                        color: theme.vars.palette.text.main
                                    }}>
                                        Dark theme
                                    </Typography>
                                    <Box 
                                        onClick={()=> {setMode(mode === "dark" ? "light" : "dark")}} 
                                        display="flex" 
                                        justifyContent={mode === "dark" ? "end" : "start"} 
                                        sx={{
                                            width: "48px", 
                                            borderRadius: "14px", 
                                            border: "2px solid", 
                                            borderColor: theme.vars.palette.primary["500"], 
                                            padding: "4px", 
                                            cursor: "pointer"
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                            <circle cx="9" cy="9" r="9" fill="#18E9E9"/>
                                        </svg>
                                    </Box>
                                </Box>
                                <Box 
                                    onClick={()=> {
                                        setChangePasswordModalOpen(true);
                                        setOpenConfiguration(false);
                                    }} 
                                    mt={4} 
                                    sx={{
                                        display: "flex",
                                        padding: "8px 16px",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        borderRadius: "12px",
                                        backgroundColor: theme.vars.palette.background.sideBar,
                                        mb: 2
                                    }}
                                >
                                    <Typography sx={{
                                        fontFamily: "Montserrat",
                                        fontSize: "16px",
                                        fontStyle: "normal",
                                        fontWeight: 700,
                                        lineHeight: "120%",
                                        color: theme.vars.palette.text.main
                                    }}>
                                        Cambiar contraseña
                                    </Typography>
                                </Box>
                                <Box 
                                    onClick={()=> closeSession()} 
                                    sx={{
                                        display: "flex",
                                        padding: "8px 16px",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        borderRadius: "12px",
                                        backgroundColor: theme.vars.palette.background.sideBar
                                    }}
                                >
                                    <Typography sx={{
                                        fontFamily: "Montserrat",
                                        fontSize: "16px",
                                        fontStyle: "normal",
                                        fontWeight: 700,
                                        lineHeight: "120%",
                                        color: theme.vars.palette.text.main
                                    }}>
                                        Cerrar sesión
                                    </Typography>
                                </Box>
                            </Box>
                        ) 
                    }
                >
                    <Box 
                        onClick={()=> {
                            setOpenConfiguration(prev => !prev)
                        }}
                        sx={{
                            position: "absolute",
                            bottom: "10px",
                            left: "45px",
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                            width: "80%",
                            height: "37px",
                            borderRadius: "8px 0px 0px 8px",
                            cursor: "pointer",
                            backgroundColor: openConfiguration ? theme.vars.palette.background.configuration : "transparent"
                        }}
                    >
                        <Typography sx={{
                            fontFamily: "Montserrat",
                            fontSize: "13px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "150%",
                            color: openConfiguration ? theme.vars.palette.background.body : theme.vars.palette.text.main
                        }}>
                            Configuración
                        </Typography>
                        <Box ml={2} mr={3} sx={{position: "relative"}}>
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.00016 15.1667H10.0002C13.3335 15.1667 14.6668 13.8334 14.6668 10.5V6.50004C14.6668 3.16671 13.3335 1.83337 10.0002 1.83337H6.00016C2.66683 1.83337 1.3335 3.16671 1.3335 6.50004V10.5C1.3335 13.8334 2.66683 15.1667 6.00016 15.1667Z" stroke={openConfiguration ? theme.vars.palette.background.body : theme.vars.palette.text.main} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M5.64648 9.47338L7.99982 7.12671L10.3532 9.47338" stroke={openConfiguration ? theme.vars.palette.background.body : theme.vars.palette.text.main} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Box>
                    </Box>
                </Tooltip>
                <Stack mt={5} alignItems="flex-end">
                    {menu && menu.length > 0 && menu.map((item, index) => (
                        <Box 
                            key={index} 
                            onClick={()=> {
                                setActiveMenuItem(index);
                                navigate(item.route);
                            }}
                            sx={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                width: "80%",
                                height: "37px",
                                borderRadius: "8px 0px 0px 8px",
                                cursor: "pointer",
                                backgroundColor: item.state === true ? theme.palette.background.body : "transparent"
                            }}
                        >
                            <Typography sx={{
                                fontFamily: "Montserrat",
                                fontSize: "13px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "150%",
                                color: theme.vars.palette.text.main
                            }}>
                                {item.name}
                            </Typography>
                            <Box ml={2} mr={3}>
                                {item.icon}
                            </Box>
                        </Box>
                    ))}
                </Stack>
            </Box>

            {/* Modal Cambiar Contraseña */}
            <Modal open={changePasswordModalOpen} onClose={() => {
                setChangePasswordModalOpen(false);
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
                setErrorMessage('');
                setSuccessMessage('');
            }}>
                <ModalDialog variant="outlined" sx={{ minWidth: 400 }}>
                    <ModalClose />
                    <DialogTitle sx={{ fontFamily: "Montserrat", fontWeight: 700, color: theme.vars.palette.primary["500"] }}>
                        Cambiar Contraseña
                    </DialogTitle>
                    <Divider />
                    <DialogContent sx={{ mt: 2 }}>
                        {errorMessage && (
                            <Box mb={2} sx={{
                                p: 2,
                                borderRadius: '8px',
                                backgroundColor: theme.vars.palette.danger[100],
                                border: `1px solid ${theme.vars.palette.danger[500]}`
                            }}>
                                <Typography sx={{
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    color: theme.vars.palette.danger[500]
                                }}>
                                    {errorMessage}
                                </Typography>
                            </Box>
                        )}
                        {successMessage && (
                            <Box mb={2} sx={{
                                p: 2,
                                borderRadius: '8px',
                                backgroundColor: theme.vars.palette.success[100],
                                border: `1px solid ${theme.vars.palette.success[500]}`
                            }}>
                                <Typography sx={{
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    color: theme.vars.palette.success[500]
                                }}>
                                    {successMessage}
                                </Typography>
                            </Box>
                        )}
                        <Box mb={3}>
                            <Typography mb={1} sx={{ fontFamily: "Montserrat", fontSize: "14px", fontWeight: 500, color: theme.vars.palette.text.main }}>
                                Contraseña Actual
                            </Typography>
                            <CustomInput
                                placeholder="Ingrese su contraseña actual"
                                width="100%"
                                password={true}
                                value={oldPassword}
                                setValue={setOldPassword}
                            />
                        </Box>
                        <Box mb={3}>
                            <Typography mb={1} sx={{ fontFamily: "Montserrat", fontSize: "14px", fontWeight: 500, color: theme.vars.palette.text.main }}>
                                Nueva Contraseña
                            </Typography>
                            <CustomInput
                                placeholder="Ingrese la nueva contraseña"
                                width="100%"
                                password={true}
                                value={newPassword}
                                setValue={setNewPassword}
                            />
                        </Box>
                        <Box>
                            <Typography mb={1} sx={{ fontFamily: "Montserrat", fontSize: "14px", fontWeight: 500, color: theme.vars.palette.text.main }}>
                                Confirmar Nueva Contraseña
                            </Typography>
                            <CustomInput
                                placeholder="Confirme la nueva contraseña"
                                width="100%"
                                password={true}
                                value={confirmPassword}
                                setValue={setConfirmPassword}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <SecondaryButton 
                            click={() => {
                                setChangePasswordModalOpen(false);
                                setOldPassword('');
                                setNewPassword('');
                                setConfirmPassword('');
                                setErrorMessage('');
                                setSuccessMessage('');
                            }} 
                            text="Cancelar" 
                        />
                        <PrimaryButton 
                            click={handleChangePassword} 
                            text="Cambiar Contraseña" 
                            loading={loadingChangePassword}
                            desactived={!oldPassword || !newPassword || !confirmPassword}
                        />
                    </DialogActions>
                </ModalDialog>
            </Modal>

        </>
    );
};

export default SideBar;